import Swiper from 'swiper'

function swipify() {
  if( document.getElementsByClassName('.hero-slider') ) {
    var s = new Swiper('.hero-slider', {
      speed: 1000,
      spaceBetween: 0,
      parallax: true,
      keyboard: true,
      loop: true,
      autoplay: {
        delay: 10000
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', function() {
  swipify()
})



// WEBPACK FOOTER //
// ./theme/_base/js/swiper.js